










import { computed, defineComponent } from '@vue/composition-api';
import { Group } from '@/store/types';

export interface Link {
	text: string;
	to?: string;
	exact?: boolean;
	disabled?: boolean;
}

export default defineComponent({
	props: {
		path: {
			type: String,
			default: '/',
		},
		groups: {
			type: Array as () => Group[],
			default: () => [],
		},
		group: {
			type: Object as () => Group,
			required: true,
		},
	},
	setup(props) {
		const links = computed<Link[]>(() => {
			const parent = props.groups.find(({ children }) => children.some(({ id }) => id === props.group.id));
			const parentLink: Link = {
				text: parent?.name ?? '',
				exact: true,
				to: `/groups/${parent?.id}`,
			};

			const ellipsis: Link = {
				text: '...',
				disabled: true,
			};

			return [
				{
					to: '/groups',
					exact: true,
					text: 'Groups',
				},
				// Conditially append disabled ellipsis element to breadcrumbs list to indicate unlisted ancestors
				...(parent?.level && parent.level > 1 ? [ellipsis] : []),
				// Conditionally append parent if it exists
				...(parent ? [parentLink] : []),
				{
					to: `/groups/${props.group.id}`,
					exact: true,
					text: props.group.name,
				},
			];
		});

		return {
			links,
		};
	},
});
